








































import { Vue, Component } from "vue-property-decorator";
import { Calendar, Checkbox, CheckboxGroup, ActionSheet, Cell, Dialog } from "vant";

import flightChange from "@/views/mall/flight/flightChange.vue";
import Flight from "@/service/flightService";
import Hotel from "@/service/hotelService";
import Train from "@/service/trainService";
import { DurationTime } from "@/utils/utils.ts";
import { forEach, times } from "lodash";
import * as _ from "lodash";
import dataShare from "@/views/mall/dataShare";
import flightDetail from "@/views/order/flight/flightDetail.vue";
import trainDetail from "@/views/order/train/trainDetail.vue";
import { ServiceType } from "@/model/Base";
@Component({
  components: {
    [Calendar.name]: Calendar,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [ActionSheet.name]: ActionSheet,
    [Cell.name]: Cell,
    flightDetail,
    trainDetail,
  },
  filters: {
    DurationTime,
  },
})
export default class extends Vue {
  //data
  dataShare = dataShare;
  productData: any = {};
  result: any[] = [];
  consumerResult: any[] = [];
  reasonShow = false;
  actions = [
    { CategoryID: 1517, name: this.$root.$t("mall_modules_change_woyaogaibianhangchengbuxiangfeiliao") as string, CategoryCode: "FlightChange", className: "itemClass" },
    { CategoryID: 1518, name: this.$root.$t("mall_modules_change_jicuohangchengriqishijianxingming") as string, CategoryCode: "FlightMistaken", className: "itemClass" },
    { CategoryID: 1519, name: this.$root.$t("mall_modules_change_hangbanyanwuhuoquxiao") as string, CategoryCode: "FlightDelay" },
  ];
  reasonVal = this.$root.$t("mall_modules_change_genjuguisidechalvbiaozhunqingxuanzegaiqianyuanyin") as string;
  isCheckInDate = false;
  DepartDate: Date = new Date();
  ArriveDate: Date = new Date();
  rulesShow = false;
  rules = [];
  comName = "";
  RefundJudges: any[] = [];
  defaultDate: any = new Date();

  get UniqueID(): string {
    return (this as any).$route.query.UniqueID;
  }
  get ServiceCode(): string {
    return (this as any).$route.query.ServiceCode;
  }
  get RuleType(): string {
    return (this as any).$route.query.RuleType;
  }
  //mounted
  mounted() {
    this.comName = this.ServiceCode.toLowerCase() + "Detail";
    this.RefundJudge();
  }
  // methods
  RefundJudge() {
    Flight.RefundJudge(this.UniqueID).then(res => {
      if (res.isSucc) {
        this.RefundJudges = res.result;
      }
    });
  }
  setResult(value: any) {
    this.result = value;
  }
  setConsumerResult(value: any) {
    this.consumerResult = value;
  }
  reasonSelect(value: any) {
    this.reasonVal = value.name;
    this.reasonShow = false;
  }
  selectChangDate() {
    if (this.result.length < 1) {
      return this.$root.$toast(this.$root.$t("mall_modules_change_qingxuanzexuyaogaiqiandelvcheng") as string);
    }
    if (this.consumerResult.length < 1) {
      return this.$root.$toast(this.$root.$t("mall_modules_change_qingxuanzelvke") as string);
    }
    if (this.result.length > 1) {
      this.defaultDate = [];
      _.forEach(this.result, item => {
        this.defaultDate.push(new Date(item.ConsumerDate));
      });
    } else {
      this.defaultDate = new Date(this.result[0].ConsumerDate);
    }

    var opl9 = this.order.ServiceType == ServiceType.FlightService && _.find(this.order.ExtraInfos, p => p.ExtraData == "OPL9");
    // opl9 = this.order.ServiceType == ServiceType.FlightService && _.find(this.order.ExtraInfos, p => p.ExtraData == "InvoiceAndItinerary");
    if (opl9) {
      Dialog.confirm({
        confirmButtonText: "继续进行改签",
        cancelButtonText: "暂不进行改签",
        cancelButtonColor: "#1989fa",
        message: "由于你选择的是航空公司官网特惠机票，如需改期将通过航空公司官方客服热线操作，退票将通过航空公司官方操作，并且退款仅限乘客本人境内银行卡!",
        messageAlign: "left",
        closeOnPopstate: true,
      })
        .then(() => {
          this.isCheckInDate = true;
        })
        .catch(() => {});
    } else {
      this.isCheckInDate = true;
    }
  }
  //日期格式化与禁用逻辑
  formatter(day: any) {
    // 当ClientUniqueID有值时，只允许选择默认日期
    if (this.order && this.order.ClientUniqueID) {
      // 默认情况下禁用所有日期
      day.type = 'disabled';
      
      // 检查day.date是否与默认日期匹配
      const isMatchDefaultDate = () => {
        // 默认日期是数组
        if (Array.isArray(this.defaultDate)) {
          return this.defaultDate.some(date => {
            const defaultDate = new Date(date);
            defaultDate.setHours(0, 0, 0, 0);
            return day.date.getTime() === defaultDate.getTime();
          });
        } 
        // 默认日期是单个日期
        else {
          const defaultDate = new Date(this.defaultDate);
          defaultDate.setHours(0, 0, 0, 0);
          return day.date.getTime() === defaultDate.getTime();
        }
      };
      
      // 只有匹配默认日期的才允许选择
      if (isMatchDefaultDate()) {
        day.type = '';
      }
    }
    
    return day;
  }
  
  //跳转列表
  selectDate(data: Date | Array<Date>) {
    this.isCheckInDate = false;
    if (data instanceof Array && data.length == 2) {
      this.DepartDate = data[0];
      this.ArriveDate = data[1];
    } else if (data instanceof Date) {
      this.DepartDate = data;
    }
    const query: any = {
      UniqueID: undefined,
      ReasonType: 0,
      ServiceType: "",
      DepartDate: "",
      ArriveDate: null,
      BookingType: 1529,
      ApplyArea: 1126,
      BerthLevel: "",
      VoyageType: 1161,
      AirwayCode: "MU",
      DepartCity: "SHA",
      ArriveCity: "BJS",
      DepartCityName: this.$root.$t("mall_modules_change_shanghai") as string,
      ArriveCityName: this.$root.$t("mall_modules_change_beijing") as string,
      ClientID: undefined,
      RuleType: "",
      Consumers: [],
      Product: "",
    };
    query.UniqueID = this.UniqueID;
    query.ServiceType = this.ServiceCode + "Service";
    query.DepartDate = this.formatDate(this.DepartDate, "YYYY-MM-DD");
    query.ClientID = this.productData.ClientID;
    query.RuleType = this.RuleType;
    if (this.result.length > 0) {
      query.Product = _.map(this.result, item => ({ FinishedCityName: item.FinishedCityName, ProductID: item.ProductID }));
      const pdt = this.result[0];
      // query.ProductID.push(pdt.ProductID);
      query.AirwayCode = pdt.ProduceCode || "";
      if (this.ServiceCode == "Flight") {
        query.ArriveCity = pdt.FinishedCityCode;
        query.DepartCity = pdt.ConsumerCityCode;
        query.ArriveCityName = pdt.FinishedCityName;
        query.DepartCityName = pdt.ConsumerCityName;
      } else {
        query.ArriveCity = pdt.FinishedZoneCode;
        query.DepartCity = pdt.ConsumerZoneCode;
        query.ArriveCityName = pdt.FinishedZoneName;
        query.DepartCityName = pdt.ConsumerZoneName;
      }
      if (this.result.length >= 2) {
        query.VoyageType = 1162;
        query.ArriveDate = this.formatDate(this.ArriveDate, "YYYY-MM-DD");
      }
    }
    query.Consumers = JSON.stringify(this.consumerResult.map((item: any) => ({ ConsumerID: item.ConsumerID, ConsumerName: item.ConsumerName })));

    dataShare.changeSource = this.result as any;

    let service = this.ServiceCode.toLowerCase();
    this.$router.push({
      path: `/mall/${service}/list`,
      query: query,
    });
  }
  formatDate(value: Date, format: string = "HH:mm") {
    if (!value) {
      return value;
    }
    return (this as any).$moment(value).format(format);
  }
  showRules(value: any) {
    if (value.BackRule == "") {
      this.$root.$toast(this.$root.$t("mall_modules_change_gaichecimeiyoupipeituigaiguize") as string);
      return;
    }
    this.rules = value.BackRule.split("；");
    this.rulesShow = true;
  }
  order: any = {};
  setProductData(value?: any) {
    this.order = value;
  }
  back(): void {
    history.back();
  }
}
